(function () {
    'use strict';


    angular.module('app.modules', [
        'contractOverview',
        'contractChooser',
        'billedUsage',
        'bankDetails',
        'addresses',
        'accountOverview',
        'dashboard',
        'directDebit',
        'documentInbox',
        'managePasswords',
        'redPlus',
        'subscriberOverview',
        'tariffOptionsExtras',
        'tariffPlans',
        'unbilledUsage',
        'unbilledUsageUte',
        'invoiceUte',
        'invoiceMartin',
        'ipMeniTariffUte',
        'ipMeniTariffCable',
        'tvMeniTariffUte',
        'tvMeniTariffCable',
        'tvMeinCable',
        'voucher',
        'cpm',
        'callSettings',
        'billHistory',
        'loginStubs',
        'emailRegistration',
        'installationCodes',
        'mobilePayments',
        'mobilePaymentChange',
        'mnp',
        'contactData',
        'orderStatus',
        'netzDslTickets',
        'billDetails',
        'connectionOverview',
        'callback',
        'notificationMessage',
        'paymentConfig',
        'accountSummary',
        'productOverview',
        'billSetting',
        'monospaced.qrcode',
        'sim-karte',
        'accountSummary',
        'dunning',
        'billNameList',
        'notifications',
        'pdfDocument',
        'billMobile'
    ]);
})();
